module.exports = __webpack_public_path__ + "images/test-img---403c3096dcb26064f65477dd5f6bfd7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/test-img.png
// module id = 1028
// module chunks = 0